import { render, staticRenderFns } from "./EnrollmentStatusModal.vue?vue&type=template&id=20f70278&scoped=true&"
import script from "./EnrollmentStatusModal.vue?vue&type=script&lang=js&"
export * from "./EnrollmentStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./EnrollmentStatusModal.vue?vue&type=style&index=0&id=20f70278&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f70278",
  null
  
)

export default component.exports